module.exports = __webpack_public_path__ + "img/intro-video-payments-poster.71ba25d2.png";